import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import { Input } from 'reactstrap';
import { productProductTypeFocusFilter } from '../../../actions';

const ProductTypeFocusFilter = () => {
  const dispatch = useDispatch();
  const { productProductLineFocus } = useSelector(({ product }) => product);

  const [focus, setFocus] = useState(productProductLineFocus);

  const handleChange = (event) => {
    const { checked } = event.target;
    setFocus(checked);
    dispatch(productProductTypeFocusFilter(checked)); // Dispatch the action with the updated checkbox value
  };

  // if(focus){
  //   console.log('focusGroup: ', focus);
  //   console.log('productProductLineFocus: ', productProductLineFocus);
  // }

  return (
    <>
      <Checkbox
        style={{ padding: '5px' }}
        color="primary"
        checked={focus}
        onChange={handleChange}
      />
      {/* <Input
        type="text"
        name="focusText"
        id="focusText"
        value={focus ? 'Y' : ''}
        onChange={() => {}}
      /> */}
    </>
  );
};

export default ProductTypeFocusFilter;